import Autocomplete from "react-autocomplete";
import { useState } from "react";
import ServiceItem from "../modules/ServiceItem";
import "./Input.css";
import success from "../../assets/icons/success-icon.svg";
import error from "../../assets/icons/error-icon.svg";
import visible from "../../assets/icons/visible-icon.svg";
import invisible from "../../assets/icons/invisible-icon.svg";
import down from "../../assets/icons/down.svg";


const DesktopSelect = (props) => {

  var itemStyle = (isHighlighted) => {
    return {
      background: isHighlighted ? "#EFEFEF" : "white",
      padding: "20px 16px",
      fontSize: "18px",
      lineHeight: "24px",
      letterSpacing: "0.4px",
      fontFamily: "Poppins",
      color: "#363636",
    };
  };

  const renderItem = (item, isHighlighted) => {
    if (props.optionType === "service") {
      return (
          <div key={item.cpt_code}>
            <ServiceItem
                key={item.cpt_code}
                service={item}
                showArrow={false}
                showUnderline={false}
                isHighlighted={isHighlighted}
                classes="service-serch-list-item"
            />
          </div>
      );
    } else {
      return (
          <div
              style={itemStyle(isHighlighted)}
              key={item.label}
              id={props.name + "-" + item.value}
              tabIndex="0"
          >
            {item.label}
          </div>
      );
    }
  };

  const shouldItemRender = (item, value) => {
    if (props.showAllOptions) {
      return true;
    } else if (props.noDropdown && value.length > 5) {
      return item.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
    } else if (!props.noDropdown) {
      return item.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
    }
  };

  const handleChange = (e) => {
    if (props.showAllOptions) {
      const value = e.target.value;
      const firstMatch = props.options.find(
          (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      if (firstMatch != null) {
        const firstMatchId = props.name + "-" + firstMatch.value;

        var myElement = document.getElementById(firstMatchId);
        var topPos = myElement.offsetTop;

        document.querySelector(
            ".input-container div div:not(.input-and-label)"
        ).scrollTop = topPos;
      }
    }

    props.onChange(e);
  }

  function handleMenuVisibilityChange(isOpen) {
    // toggleArrow(isOpen);

    if (!isOpen && props.showAllOptions) {
      const value = props.value == null ? "" : props.value;
      const options = props.options;

      const firstMatch = options.find(
          (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      if (firstMatch != null) {
        props.onSelect(firstMatch.label, props.name);
      } else {
        props.onSelect(options[0]?.label, props.name);
      }
    }
  }

  function determineClassName() {
    if (props.readOnly) {
      return "read-only";
    } else if (props.selectOnly) {
      return "writeable select-only";
    } else {
      return "writeable";
    }
  }

  return (
      <Autocomplete
          onMenuVisibilityChange={(isOpen) => handleMenuVisibilityChange(isOpen)}
          getItemValue={(item) => item.label}
          items={props.options}
          shouldItemRender={(item, value) => shouldItemRender(item, value)}
          renderItem={(item, isHighlighted) => renderItem(item, isHighlighted)}
          renderInput={function (props) {
            return (
                <div className="input-and-label" key={props.name}>
                  <input {...props} className={determineClassName()} />
                  <label htmlFor={props.name}> {props.label} </label>
                </div>
            );
          }}
          inputProps={{
            placeholder: props.placeholder,
            id: props.name,
            name: props.name,
            label: props.label,
            required:
                typeof props.required !== "undefined" ? props.required : true,
          }}
          value={props.value}
          onChange={(e) => (props.selectOnly ? null : handleChange(e))}
          onSelect={(val) => props.onSelect(val, props.name)}
          selectOnBlur={
            !props.options.find((item) => item.label === props.value)
          }
          menuStyle={{
            borderRadius: "0px 0px 4px 4px",
            boxShadow: "0 0px 6px rgba(0, 0, 0, 0.1)",
            background: "#FFFFFF",
            position: "absolute",
            top: "unset",
            right: "0",
            left: "0",
            overflow: "auto",
            maxHeight: "256px",
            zIndex: "100",
            cursor: "pointer",
          }}
      />
  );
};

const MobileSelect = (props) => {
  const options = props.options;
  let optionsList =
      options.length > 0 &&
      options.map((item, i) => {
        let key = props.name + "-" + item.value;
        if (item.disabled) {
          return (
              <option key={key} value={item.value} disabled>
                {item.label}
              </option>
          );
        } else {
          return (
              <option key={key} value={item.value}>
                {item.label}
              </option>
          );
        }
      }, this);

  return (
      <select
          name={props.name}
          id={props.name}
          onChange={(e) => props.onSelect(e.target.value, props.name)}
      >
        <option value="" disabled selected>
          {props.placeholder}
        </option>
        {optionsList}
      </select>
  );
};

const TextInput = (props) => {
  return (
      <div className="input-and-label" key={props.name}>
        <input
            style={props.style}
            ref={props.ref}
            type={props.type === "password" ? "password" : "text"}
            value={props.value}
            defaultValue={props.defaultValue}
            name={props.name}
            id={props.name}
            placeholder={props.placeholder}
            required={
              typeof props.required !== "undefined" ? props.required : true
            }
            readOnly={props.readOnly}
            onChange={props.onChange}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            className={
              props.readOnly
                  ? props.grayOut
                      ? "read-only read-only-alt"
                      : "read-only"
                  : "writeable"
            }
        />
        <label htmlFor={props.name}> {props.label} </label>
      </div>
  );
};


const AutotypeInput = (props) => {
  let display = null;
  if (props.options && !props.readOnly) {
    if (props.forceAutocomplete) {
      display = DesktopSelect(props);
    } else {
      display = window.innerWidth <= 768 ? MobileSelect(props) : DesktopSelect(props);
    }
  } else {
    display = TextInput(props);
  }

  return display;
}


const displayIcon = (props) => {
  const arrow_direction = 'down'  // props.arrowDirection
  if (props.showErrorMessage && props.showErrorIcon) {
    return <img src={error} className="input-icon" />;
  } else if (props.showValidMessage) {
    return <img src={success} className="input-icon" />;
  } else if (props.showArrow) {
    let arrowClasses = "input-arrow input-icon" + arrow_direction;
    return <span className={arrowClasses}></span>;
  } else if (props.showDropdownArrow) {
    return <img src={down} className="input-icon" />;
  } else if (props.showVisibilityToggle) {
    let visibility = props.type === "password" ? invisible : visible;
    return (
        <img
            src={visibility}
            className="input-icon"
            onClick={props.iconOnClick}
        />
    );
  } else if (props.showInputActions) {
    if (props.readOnly) {
      return (
          <span className="input-icon input-action" onClick={props.iconOnClick}>
            SAVE
          </span>
      );
    } else if (props.readOnly && !props.value) {
      return (
          <span className="input-icon input-action" onClick={props.iconOnClick}>
            ADD
          </span>
      );
    } else {
      return (
          <span className="input-icon input-action" onClick={props.iconOnClick}>
            EDIT
          </span>
      );
    }
  } else {
    return null;
  }
}

function displayHelpText(props) {
  if (props.showErrorMessage) {
    return <div className="input-message error">{props.errorMessage}</div>;
  } else if (props.showValidMessage) {
    return <div className="input-message valid">{props.validMessage}</div>;
  } else if (props.helpText) {
    return <div className="input-message">{props.helpText}</div>;
  } else {
    return null;
  }
}

function Input(props) {
  var inputContainerClasses = "input-container " + props.inputContainerClasses;


  if (props.hide) {
    return null;
  } else {
    return (
      <div className={inputContainerClasses}>
        {AutotypeInput(props)}
        {displayIcon(props)}
        {displayHelpText(props)}
      </div>
    );
  }
}

export default Input;
